import angular from 'angular';

/**
 * @ngdoc overview
 * @name superuserModule.superuserDirectives
 * @description
 * # superuserModule.superuserDirectives
 * Module for managing the common directives.
 */
const productsDirectives = angular.module('applicationModule.productsDirectives', []);

/**
 * @ngdoc directive
 * @name superuserModule.superuserDirectives.directive:readWriteModules
 * @description
 * Directive for displaying read/write buttons for each modules
 */
productsDirectives.directive('categories', () => {
    'use strict';
    return {
        restrict: 'A',
        replace: true,
        scope: {
            data: '=ngModel'
        },
        controller: ['$scope', function ($scope) {
            $scope.empty = (angular.isUndefined($scope.data));
        }],
        templateUrl: 'views/application/products/directives/categories.tpl.html'
    };
});

export default productsDirectives;
